"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2734,239],{

/***/ 42227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ fromUnixTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */

function fromUnixTime(dirtyUnixTime) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var unixTime = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyUnixTime);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(unixTime * 1000);
}

/***/ }),

/***/ 70879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ de; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018

};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(88486);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/localize/index.js

var eraValues = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/

var formattingMonthValues = {
  narrow: monthValues.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: monthValues.wide
};
var dayValues = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

var dayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    formattingValues: formattingMonthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(76723);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(60974);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`

  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/de/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var locale = {
  code: 'de',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var de = (locale);

/***/ }),

/***/ 30239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CommentForm": function() { return /* binding */ CommentForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(80419);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(83234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(74995);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 2 modules
var checkbox_dist_index_esm = __webpack_require__(53749);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./src/graphql/CreateCommentQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateComment($data: CreateCommentInput!) {\n    createComment(data: $data) {\n      errors\n      created\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var QueryCreateComment = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./src/context/PageContext.ts
var PageContext = __webpack_require__(40353);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Forms/CommentForm.tsx













var CommentForm = function(param) {
    var onParentSubmit = param.onSubmit, parentCommentId = param.parentCommentId;
    var ref, ref1, ref2, ref3;
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    var toast = (0,dist_index_esm/* useToast */.pm)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(QueryCreateComment), 1), createComment = ref4[0];
    var ref5 = (0,index_esm/* useForm */.cI)(), register = ref5.register, setValue = ref5.setValue, handleSubmit = ref5.handleSubmit, watch = ref5.watch, reset = ref5.reset, _formState = ref5.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, ref1, ref2, data, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return createComment({
                            variables: {
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                    entityId: ((ref = pageContext.entity) === null || ref === void 0 ? void 0 : ref.id) || 0,
                                    parentCommentId: parentCommentId
                                })
                            }
                        });
                    case 3:
                        ref2 = _ctx.sent;
                        data = ref2.data;
                        errors = ref2.errors;
                        if (data === null || data === void 0 ? void 0 : (ref1 = data.createComment) === null || ref1 === void 0 ? void 0 : ref1.created) {
                            toast({
                                title: "Kommentar eingereicht.",
                                description: "Vielen Dank f\xfcr Deinen Kommentar und Deine Mithilfe. Unsere Redaktion wird den Kommentar in den n\xe4chsten Tagen zum Artikel ver\xf6ffentlichen. Wir sind Trabland.",
                                status: "success",
                                duration: 9000,
                                isClosable: true
                            });
                            reset();
                            onParentSubmit && onParentSubmit();
                        } else {
                            toast({
                                title: "Fehler.",
                                description: "Es ist ein Fehler aufgetreten. Bitte versuche es sp\xe4ter erneut.",
                                status: "error",
                                duration: 9000,
                                isClosable: true
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                isInvalid: !!errors.name,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "name",
                        children: "Name (wird nicht ver\xf6ffentlicht)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        bg: "white",
                        id: "name",
                        placeholder: "Name"
                    }, register("name", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref = errors.name) === null || ref === void 0 ? void 0 : ref.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.username,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "username",
                        children: "Ver\xf6ffentlichter Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        bg: "white",
                        id: "username",
                        placeholder: "Ver\xf6ffentlichter Name"
                    }, register("username", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref1 = errors.username) === null || ref1 === void 0 ? void 0 : ref1.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.email,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "email",
                        children: "E-Mail (wird nicht ver\xf6ffentlicht)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                        bg: "white",
                        id: "email",
                        type: "email",
                        placeholder: "E-Mail"
                    }, register("email", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref2 = errors.email) === null || ref2 === void 0 ? void 0 : ref2.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.comment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                        htmlFor: "comment",
                        children: "Kommentar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread/* default */.Z)({
                        bg: "white",
                        rows: 5,
                        id: "comment"
                    }, register("comment", {
                        required: true
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: (ref3 = errors.comment) === null || ref3 === void 0 ? void 0 : ref3.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                mt: 4,
                isInvalid: !!errors.privacy,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkbox_dist_index_esm/* Checkbox */.XZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        mt: 4
                    }, register("privacy", {
                        required: true
                    })), {
                        children: [
                            "Ich habe die",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/impressum-datenschutz",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                    fontWeight: "bold",
                                    as: "a",
                                    textDecoration: "underline",
                                    children: "Datenschutzerkl\xe4rung"
                                })
                            }),
                            " ",
                            "gelesen und akzeptiere sie."
                        ]
                    })),
                    errors.privacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                        children: "Du musst die Datenschutzerkl\xe4rung akzeptieren"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                id: "_bp",
                type: "hidden",
                placeholder: "BP"
            }, register("_bp"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                justifyContent: "flex-end",
                mt: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                    width: "100%",
                    variant: "roundBlue",
                    isLoading: isSubmitting,
                    type: "submit",
                    children: "Kommentar einreichen"
                })
            })
        ]
    });
};


/***/ }),

/***/ 2734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CommentListAndFormular": function() { return /* reexport */ CommentListAndFormular; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./src/components/Forms/CommentForm.tsx + 1 modules
var CommentForm = __webpack_require__(30239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 27 modules
var format = __webpack_require__(8085);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
;// CONCATENATED MODULE: ./src/components/Common/Comment.tsx









var NestedComments = function(param) {
    var data = param.data, onClickAnswer = param.onClickAnswer, openCommentIdForm = param.openCommentIdForm;
    if (!data.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* VStack */.gC, {
        pt: 6,
        mt: 6,
        spacing: 6,
        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
            borderColor: "gray.200",
            opacity: 1
        }),
        ml: 9,
        borderTop: "1px solid",
        borderTopColor: "gray.100",
        children: data.map(function(comment) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, {
                data: comment,
                onClickAnswer: onClickAnswer,
                openCommentIdForm: openCommentIdForm
            }, comment.id);
        })
    });
};
var Comment = function(_param) {
    var data = _param.data, onClickAnswer = _param.onClickAnswer, openCommentIdForm = _param.openCommentIdForm, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onClickAnswer",
        "openCommentIdForm"
    ]);
    var isFormOpen = openCommentIdForm === data.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        fontWeight: "bold",
                        children: data.username || "Gast"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        fontSize: "sm",
                        children: (0,format/* default */.Z)((0,fromUnixTime/* default */.Z)(data.created), "dd MMMM yyyy", {
                            locale: de/* default */.Z
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                mt: 4,
                dangerouslySetInnerHTML: {
                    __html: data.comment
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: isFormOpen,
                animateOpacity: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                    bg: "gray.50",
                    p: 6,
                    mt: 9,
                    border: "1px solid",
                    borderColor: "gray.400",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                            fontSize: "xl",
                            mb: 4,
                            fontWeight: 500,
                            as: "h3",
                            color: "primary",
                            children: [
                                "Auf den Kommentar von ",
                                data.username || "Gast",
                                " antworten"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentForm.CommentForm, {
                            parentCommentId: data.id
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: !isFormOpen,
                animateOpacity: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        size: "sm",
                        mt: 12,
                        onClick: function() {
                            onClickAnswer(data.id);
                        },
                        children: "Antworten"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NestedComments, {
                data: data.children,
                onClickAnswer: onClickAnswer,
                openCommentIdForm: openCommentIdForm
            })
        ]
    }), data.id);
};

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./src/graphql/fragments/Comment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment Comment on Comment {\n    id\n    thread\n    subject\n    username\n    created\n    comment\n    parentComment {\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CommentFragment = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/graphql/LoadMoreCommentsQuery.ts

function LoadMoreCommentsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LoadComments($entityId: Int!, $offset: Int!) {\n    loadMoreComments(entityId: $entityId, offset: $offset) {\n      ...Comment\n    }\n  }\n\n  ",
        "\n"
    ]);
    LoadMoreCommentsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var QueryLoadComments = (0,lib/* gql */.Ps)(LoadMoreCommentsQuery_templateObject(), CommentFragment);

// EXTERNAL MODULE: ./src/context/PageContext.ts
var PageContext = __webpack_require__(40353);
;// CONCATENATED MODULE: ./src/components/Paragraph/CommentListAndFormular/CommentListAndFormular.tsx














var CommentListAndFormular = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(data.comments), comments = ref[0], setComments = ref[1];
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(QueryLoadComments, {}), 2), loadComments = ref1[0], ref2 = ref1[1], loading = ref2.loading, loadCommentsData = ref2.data, error = ref2.error;
    var groupedComments = (0,react.useMemo)(function() {
        var map = new Map();
        var groups = [];
        comments.forEach(function(comment) {
            map.set(comment.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                children: []
            }));
        });
        comments.forEach(function(comment) {
            var ref;
            var commentItem = map.get(comment.id);
            if (((ref = comment.parentComment) === null || ref === void 0 ? void 0 : ref.id) && map.has(comment.parentComment.id)) {
                map.get(comment.parentComment.id).children.push(commentItem);
            } else {
                groups.push(commentItem);
            }
        });
        return groups;
    }, [
        comments
    ]);
    var onLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return loadComments({
                            variables: {
                                entityId: pageContext.entity.id,
                                offset: comments.length
                            }
                        });
                    case 3:
                        result = _ctx.sent;
                        if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.loadMoreComments) {
                            setComments((0,_to_consumable_array/* default */.Z)(comments).concat((0,_to_consumable_array/* default */.Z)(result.data.loadMoreComments)));
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react.useState)(null), openCommentIdForm = ref3[0], setOpenCommentIdForm = ref3[1];
    var ref4 = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref4.isOpen, onOpen = ref4.onOpen, onClose = ref4.onClose;
    var toggleCommentIdForm = function(id) {
        onClose();
        setOpenCommentIdForm(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        borderTop: "1px solid",
        borderTopColor: "gray.300",
        pt: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                fontSize: "2xl",
                mb: 4,
                fontWeight: 500,
                as: "h3",
                color: "primary",
                children: [
                    "Kommentare (",
                    data.totalComments,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* VStack */.gC, {
                spacing: 6,
                divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                    borderColor: "gray.200",
                    opacity: 1
                }),
                color: "primary",
                children: groupedComments.map(function(comment) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, {
                        data: comment,
                        onClickAnswer: toggleCommentIdForm,
                        openCommentIdForm: openCommentIdForm
                    }, comment.id);
                })
            }),
            comments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                py: 6,
                mt: 6,
                borderTop: "1px solid",
                borderTopColor: "gray.100",
                color: "primary",
                alignItems: "center",
                flexDir: "column",
                children: [
                    comments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                        fontSize: "sm",
                        children: [
                            "Kommentare 1 - ",
                            comments.length,
                            " von ",
                            data.totalComments
                        ]
                    }),
                    data.totalComments > comments.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        isLoading: loading,
                        mt: 2,
                        size: "sm",
                        onClick: onLoadMore,
                        children: "Mehr Kommentare laden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                    bg: "gray.50",
                    p: 6,
                    mt: 9,
                    border: "1px solid",
                    borderColor: "gray.400",
                    children: [
                        data.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                            fontSize: "2xl",
                            mb: 6,
                            fontWeight: 500,
                            as: "h3",
                            color: "primary",
                            children: data.headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentForm.CommentForm, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_dist_index_esm/* Collapse */.UO, {
                in: !isOpen,
                animateOpacity: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        mt: 12,
                        variant: "roundBlue",
                        onClick: function() {
                            setOpenCommentIdForm(null);
                            onOpen();
                        },
                        children: "Kommentar schreiben"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/CommentListAndFormular/index.ts



/***/ })

}]);